export default __webpack_public_path__ + "static/media/loading_logo_color.5a830643.gif";